import { render, staticRenderFns } from "./TurnoverPerMonthGraph.vue?vue&type=template&id=68b7b5de&scoped=true"
import script from "./TurnoverPerMonthGraph.vue?vue&type=script&lang=ts"
export * from "./TurnoverPerMonthGraph.vue?vue&type=script&lang=ts"
import style0 from "./TurnoverPerMonthGraph.vue?vue&type=style&index=0&id=68b7b5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7b5de",
  null
  
)

export default component.exports